function onPlaylistItem(event) {
    this.setState({
      hasFired: {},
      elapsedStart: new Date()
    })
}

export default onPlaylistItem
